import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.define-property";
import "core-js/modules/web.dom-collections.for-each";
import { __decorate, __extends } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { isUndef } from '@/lib/utils';
/**
 * 使用v-model绑定数据
 *
 * @input(index) 点击事件，其中index是navigations的索引
 */

var SlideNav =
/** @class */
function (_super) {
  __extends(SlideNav, _super);

  function SlideNav() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 处理value，暂时使用scrollIntoView，让tab进入到parent中
   */


  SlideNav.prototype.onChangeValue = function (val) {
    if (this.isScrollIntoView) {
      var el = this.$refs[val];

      if (el && el.scrollIntoView) {
        el.scrollIntoView();
      }
    }
  };

  SlideNav.prototype.onIsScrollIntoViewChanged = function (val) {
    if (val) {
      var el = this.$refs[this.value];

      if (el && el.scrollIntoView) {
        el.scrollIntoView();
      }
    }
  };

  Object.defineProperty(SlideNav.prototype, "percentage", {
    /**
     * 移动的距离
     */
    get: function get() {
      if (isUndef(this.navigations) || this.navigations.length === 0) {
        return 0;
      } else {
        return (1 / this.navigations.length * 100).toFixed(2);
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SlideNav.prototype, "selectedIndex", {
    /**
     * 所选择的index
     */
    get: function get() {
      var _this = this;

      var result = 0;
      this.navigations.forEach(function (navigation, index) {
        if (navigation.value === _this.value) {
          result = index;
        }
      });
      return result;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 点击选项
   */

  SlideNav.prototype.onClick = function (value) {
    this.$emit('input', value);
  };

  SlideNav.prototype.mounted = function () {
    if (this.isScrollIntoView) {
      var el = this.$refs[this.value];

      if (el && el.scrollIntoView) {
        el.scrollIntoView();
      }
    }
  };

  __decorate([Prop({
    required: true,
    type: Array,
    "default": function _default() {
      return [];
    }
  })], SlideNav.prototype, "navigations", void 0);

  __decorate([Prop({
    type: [String, Number]
  })], SlideNav.prototype, "value", void 0);

  __decorate([Prop({
    type: [Object, Array]
  })], SlideNav.prototype, "containerClass", void 0);

  __decorate([Prop({
    type: [Object, Array]
  })], SlideNav.prototype, "wrapClass", void 0);

  __decorate([Prop({
    type: [Object, Array]
  })], SlideNav.prototype, "itemClass", void 0);

  __decorate([Prop({
    type: [Object, Array]
  })], SlideNav.prototype, "indicatorClass", void 0);

  __decorate([Prop({
    type: String,
    "default": 'center'
  })], SlideNav.prototype, "contentPosition", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], SlideNav.prototype, "isScrollIntoView", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], SlideNav.prototype, "indicatorVisible", void 0);

  __decorate([Watch('value')], SlideNav.prototype, "onChangeValue", null);

  __decorate([Watch('isScrollIntoView')], SlideNav.prototype, "onIsScrollIntoViewChanged", null);

  SlideNav = __decorate([Component({
    name: 'SlideNav'
  })], SlideNav);
  return SlideNav;
}(Vue);

export default SlideNav;